require('./angular-cookies');
module.exports = 'ngCookies';



/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/~/angular-cookies/index.js
 ** module id = 201
 ** module chunks = 0
 **/